import { render, staticRenderFns } from "./selected-items-header.vue?vue&type=template&id=53664f32&scoped=true"
import script from "./selected-items-header.vue?vue&type=script&lang=js"
export * from "./selected-items-header.vue?vue&type=script&lang=js"
import style0 from "./selected-items-header.vue?vue&type=style&index=0&id=53664f32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53664f32",
  null
  
)

export default component.exports